// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4ebca821","455":"57b5cd21"}[chunkId] + ".chunk.js";
};